import {TaskQueue} from "aurelia-framework";
import {instance} from "../tools/di";

export class Event {
  sender?: any;

  constructor(sender?: any) {
    this.sender = sender;
    instance(TaskQueue).queueMicroTask(() => Object.freeze(this));
  }
}
